'use client';

import { useEffect, useState } from 'react';

const NAV_SECTIONS = ['o-nas', 'serwis', 'porady', 'wycieczki', 'kontakt'];

export function useHeaderScroll() {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('o-nas');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 340);

      // Check if reached the bottom of the page
      const isAtBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 50;

      if (isAtBottom) {
        setActiveSection(NAV_SECTIONS[NAV_SECTIONS.length - 1]);

        return;
      }

      // Find the last section that has scrolled past the top threshold (150px)
      let currentSection = NAV_SECTIONS[0];

      for (const sectionId of NAV_SECTIONS) {
        const el = document.getElementById(sectionId);

        if (el) {
          const rect = el.getBoundingClientRect();

          if (rect.top <= 150) {
            currentSection = sectionId;
          }
        }
      }

      setActiveSection(currentSection);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { scrolled, activeSection, setActiveSection };
}
